function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21",
  height: "22",
  viewBox: "0 0 21 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.846 4.653c0-3.027 3.232-4.957 5.897-3.522l11.563 6.226c2.804 1.51 2.804 5.534 0 7.044L6.743 20.627C4.078 22.062.846 20.132.846 17.105V4.653z",
  fill: "#fff"
})));